import { appendBasePath } from 'common/navUtils';
import { ATBeaconButton } from 'components/common/beacon/beaconRegistration';
import React from 'react';
import ErrorIcon from 'src/components/common/icons/Error';
import { CTAVariants } from '@trp-beacon-ui-kit/foundation/dist/_common/types/cta-variant';
import './Errorpage.scss';

export default function Errorpage() {
  const handleTryAgain = () => {
    window.location.href = appendBasePath('/');
  };

  return (
    <div className="error-page" data-testid="error-page">
      <ErrorIcon className="error-icon" />
      <label className="b-typography-serif--headline--500 b-font-weight-bold error-message">
        We are having technical issues
      </label>
      <label className="b-typography-sans-serif--body--200 b-font-weight-light">
        Please come back later and try again.
      </label>
      <ATBeaconButton
        className="error-message"
        variant={CTAVariants.Primary}
        onClick={handleTryAgain}
      >
        Try Again
      </ATBeaconButton>
    </div>
  );
}
